import { css } from 'twin.macro';

import { useSuccessfulLogin } from '@auth_module/hooks/useSuccessfulLogin';
import { Layout } from '@auth_module/components/Layout';
import { LoginForm } from '@auth_module/components/LoginForm';
import { withTitle } from '@hoc/withTitle';
import { useAuthParams } from '@auth_module/hooks/useAuthParams';
import { SounderLogo } from '@icons/SounderLogo';
import loginGraphic from '@assets/images/login-graphic.svg';

const backgroundImage = css`
  background-image: url(${loginGraphic});
`;

const _LoginPage = () => {
  const { handleSuccessLogin } = useSuccessfulLogin({ navigateTo: '/' });
  const [{ cid }] = useAuthParams();

  return (
    <>
      <Layout
        tw='md:top-[calc(50% - 200px)] md:max-w-[480px]'
        backgroundCss={backgroundImage}
        header={
          <div tw='absolute top-0 left-0 w-full flex justify-between items-center z-30 px-[48px] pt-[30px]'>
            <SounderLogo tw='w-[31px] h-[42px] fill-accent-1 md:fill-text-and-icon-invert' />
            <div tw='flex gap-[12px] items-center'>
              <p tw='text-[16px] font-semibold text-accent-1 md:text-text-and-icon-invert'>
                Don’t have an account?
              </p>
              <a
                target='_blank'
                rel='noreferrer'
                href='https://www.sounder.ai/en/contact'
                tw='flex h-[40px] px-[19px] justify-center items-center rounded bg-[rgba(255, 255, 255, 0.10)] text-[16px] font-semibold text-accent-1 md:text-text-and-icon-invert cursor-pointer no-underline'>
                Contact Us
              </a>
            </div>
          </div>
        }>
        <LoginForm handleSuccessLogin={handleSuccessLogin} cid={cid || undefined} />
      </Layout>
    </>
  );
};

export const LoginPage = withTitle(_LoginPage, 'auth.login_page.title');
